// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"276ad449","927":"ad7b3a38"}[chunkId] + ".chunk.js";
};